module.exports = __webpack_public_path__ + "static/media/dog_logo.275ea08a.png";